import clsx from 'clsx';
import Image from 'next/image';
import styles from './Logo.module.scss';

interface LogoProps {
  src: string;
  srcSet?: string;
  alt: string;
  width: number;
  height: number;
  logoSize?: 'sm' | 'md' | 'lg';
  align?: 'start' | 'center' | 'end';
  className?: string;
  testId?: string;
}

export const Logo: React.FC<LogoProps> = ({
  src,
  srcSet,
  alt,
  width,
  height,
  logoSize = 'md',
  align = 'start',
  className,
  testId,
}) => (
  <Image
    src={src}
    src-set={srcSet}
    alt={alt}
    width={width}
    height={height}
    className={clsx(styles.logo, styles[`logo-${logoSize}`], styles[`align-${align}`], className)}
    data-testid={testId}
  />
);
